import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { CONTACT_TYPES } from '../../shared/constants/api-constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-passengers-list',
  templateUrl: './passengers-list.component.html',
  styleUrls: ['./passengers-list.component.scss'],
})
export class PassengersListComponent  implements OnInit {

  @Input() leadId:any;

  allLeadguests:any= {
    data: [],
    pageNumber: 1,
    pageSize: 10
  };
  leadPassengersColumns: any = [
    { key: "contactId", colName: "Contact ID", showColumn: true},
    { key: "firstName", colName: "Name", showColumn: true},
    { key: "phoneNumber", colName: "Phone Number", showColumn: true},
    { key: "dateOfBirth", colName: "DOB", showColumn: true},
    { key: "gender", colName: "Gender", showColumn: true},
    { key: "document", colName: "Documents", showColumn: true},
  ]

  constructor(
    private _contactService: ContactsService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _router: Router
  ) { }

  ngOnInit() {

    this.getDefaultContactsForLead();

    this._reloadService.reloadContacts$.subscribe(()=>{
      this.getDefaultContactsForLead()
    })
  }

  async deletePassengerRow(contactId:any){
    if(await this._globalService.confirmActionPopup(`Confirm to delete contact ${contactId}`)){
      this._contactService.deleteContactOfLead(contactId).subscribe((data)=>{
        this._responseNotificationService.showMessage("Contact Deleted Successfully!")
        this._reloadService.triggerContactsReload()
      })
    }
  }

  editPassengerOpen(contactId:any){
    this._modalPopupService.openContactForm(CONTACT_TYPES.PASSENGER, this.leadId, contactId, true, ()=>{
      this._reloadService.triggerContactsReload()
    })
  }
  
  viewPassenger(contactId:any){
    this._router.navigate(['contacts/contact-details', contactId]);
  }


  getDefaultContactsForLead(){
    this._contactService.getAllContactsForLead(this.leadId, null, null, null).subscribe((data)=>{
      this.allLeadguests = data;
    })
  }

  // Open contactForm
  openContactForm(){
    this._modalPopupService.openContactForm(CONTACT_TYPES.PASSENGER, this.leadId, null, true, ()=>{
      this.getDefaultContactsForLead();
    })
  }

  getAllContacts(paginationData: any) {
    this._contactService.getAllContactsForLead(this.leadId,paginationData.pageNumber,paginationData.pageSize, null).subscribe((data)=>{
      this.allLeadguests = data;
    })
  }

  
}
